import { Text } from "@radix-ui/themes";

export const fixToTwo = (n: number): number => parseFloat(n?.toFixed(2));

export const formatWithCommas = (n: number, locale: string = "en-US"): string =>
  n.toLocaleString(locale);

export function CSATFormatter({ value }: { value: number }) {
  return (
    <Text>
      {formatWithCommas(fixToTwo(+value))} /{" "}
      <Text as="span" color="gray">
        5
      </Text>
    </Text>
  );
}
